import React from "react";
import { AuthProvider } from "react-oidc-context";
import { cognitoAuthConfig } from "./src/auth/cognitoAuthConfig";
import { CartProvider } from "./src/shop/cartContext";

export const wrapRootElement = ({ element }) => (
  <AuthProvider {...cognitoAuthConfig}>
    <CartProvider>{element}</CartProvider>
  </AuthProvider>
);
